import axiosApi from '@/plugins/axiosInstance';

const PAGE_VIEW_EVENT = 'page_view';
const SOURCE = 'supervisor';

export const recordPageView = (to) => {
  const allowAnonymous = to.matched?.some((record) => record.meta.allowAnonymous);
  if (allowAnonymous) {
    return;
  }

  axiosApi
    .post('api/v1/user-activity/events', {
      eventType: PAGE_VIEW_EVENT,
      source: SOURCE,
      pageTitle: to.name?.toString() || to.meta?.title || to.path,
      pagePath: to.fullPath || to.path,
      occurredAt: new Date().toISOString(),
      metadata: {},
    })
    .catch(() => {});
};
